import Cookies from 'js-cookie';

export interface CookieConsentPreferences {
  v: number;
  necessary: boolean;
  functional: boolean;
  analytics: boolean;
  marketing: boolean;
  updatedAt: string;
}

const COOKIE_NAME = 'cookie_consent';
const COOKIE_VERSION = 1;

export function getConsentPreferences(): CookieConsentPreferences | null {
  try {
    const raw = Cookies.get(COOKIE_NAME);
    if (!raw) return null;
    const parsed: CookieConsentPreferences = JSON.parse(raw);
    if (parsed.v !== COOKIE_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setConsentPreferences(
  prefs: Pick<CookieConsentPreferences, 'functional' | 'analytics' | 'marketing'>
): void {
  const consent: CookieConsentPreferences = {
    v: COOKIE_VERSION,
    necessary: true,
    functional: prefs.functional,
    analytics: prefs.analytics,
    marketing: prefs.marketing,
    updatedAt: new Date().toISOString(),
  };
  Cookies.set(COOKIE_NAME, JSON.stringify(consent), {
    expires: 365,
    path: '/',
    secure: window.location.protocol === 'https:',
    sameSite: 'Lax',
  });
  pushConsentToGTM(prefs);
}

export function acceptAllConsent(): void {
  setConsentPreferences({ functional: true, analytics: true, marketing: false });
}

export function initGTMConsent(): void {
  const prefs = getConsentPreferences();
  if (prefs) {
    pushConsentToGTM(prefs);
  }
}

function pushConsentToGTM(prefs: Pick<CookieConsentPreferences, 'functional' | 'analytics' | 'marketing'>): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function gtag(..._args: any[]) { ((window as any).dataLayer = (window as any).dataLayer || []).push(arguments); }
  gtag('consent', 'update', {
    analytics_storage: prefs.analytics ? 'granted' : 'denied',
    functionality_storage: prefs.functional ? 'granted' : 'denied',
    ad_storage: prefs.marketing ? 'granted' : 'denied',
    ad_user_data: prefs.marketing ? 'granted' : 'denied',
    ad_personalization: prefs.marketing ? 'granted' : 'denied',
  });
}

export function hasConsented(): boolean {
  return getConsentPreferences() !== null;
}

export function hasAnalyticsConsent(): boolean {
  return getConsentPreferences()?.analytics === true;
}
